import { useTranslation } from "i18n";
import useGetReps from "pages/Profile/hooks/useGetReps";
import { getAgentAddress, getAgentPhones } from "pages/Profile/utils/common";

const RepsPrint = () => {
  const { t } = useTranslation();
  const {
    agents = [],
    schools = [],
    isSelfRepresented,
    isLookingForRepresentation,
  } = useGetReps();

  const agentLists = [
    ...agents,
    ...schools.map((school) => ({
      ...school,
      name: t("performer:profile.training.title.named", { name: school.name }),
    })),
  ];

  return (
    <div className="grid grid-cols-3 gap-4">
      {isSelfRepresented && (
        <div>
          <p className="mb-0.5 text-xs font-bold uppercase">
            {t("performer:profile.representation.selfRepresented")}
          </p>
          {isLookingForRepresentation && (
            <p className="text-xs">
              {t("performer:profile.representation.seekingRepresentation")}
            </p>
          )}
        </div>
      )}

      {agentLists.map((agent) => {
        const address = getAgentAddress(agent);

        const phoneNumbers = getAgentPhones(agent);

        return (
          <div key={agent.refNumber}>
            <p className="text-xs font-bold uppercase">{agent.name}</p>
            {address && <p className="text-xs">{address}</p>}
            {phoneNumbers && (
              <p className="text-xs">
                <span className="flex">
                  <span>{t("common:label.tel.colon")}</span>{" "}
                  <span>{phoneNumbers}</span>
                </span>
              </p>
            )}
            {agent.email && <p className="text-xs">{agent.email}</p>}
            {agent.website && <p className="text-xs">{agent.website}</p>}
          </div>
        );
      })}
    </div>
  );
};

export default RepsPrint;
